"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringify = void 0;
function isNullOrUndefined(o) {
    return o === undefined || o === null;
}
function stringify(object) {
    if (!object) {
        return '';
    }
    const filteredObject = {};
    for (const key of Object.keys(object)) {
        if (!isNullOrUndefined(object[key]) && object[key] !== '') {
            filteredObject[key] = object[key];
        }
    }
    const keys = Object.keys(filteredObject);
    return keys
        .map(key => {
        const value = object[key];
        if (Array.isArray(value)) {
            if (value.length === 0) {
                return encodeURIComponent(key) + '[]';
            }
            const res = [];
            for (const item of value) {
                if (!isNullOrUndefined(item)) {
                    res.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
                }
            }
            return res.join('&');
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
        .join('&');
}
exports.stringify = stringify;
//# sourceMappingURL=Qs.js.map